import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import IMAGE_1 from "./images/imgi_46_6.jpg";
import ContactForm from "../web_core/Form";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      title: "Learn Quran Online with Qualified Teachers",
      description: "Trusted Online Quran Academy for the UK, USA & Canada",
      cta: "Find The Course",
      navigateTo: "/courses" // Slide 1: go to Courses page
    },
    {
      title: "Online Quran Classes",
      description: "Master the art of Quranic recitation and translation",
      cta: "Start Learning",
      navigateTo: "/lead-form" // Slide 2: scroll to ContactForm
    },
    {
      title: "Islamic Studies for All Ages",
      description:
        "Age-appropriate curriculum designed for children, youth, and adults",
      cta: "View Courses",
      navigateTo: "/courses" // Slide 3: go to Courses page
    },
  ];

  const stats = [
    { value: "1K+", label: "Students Enrolled" },
    { value: "40+", label: "Certified Teachers" },
    { value: "25+", label: "Countries" },
    { value: "15+", label: "Years Experience" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleCTA = () => {
    const currentSlideData = slides[currentSlide];

    if (currentSlideData.navigateTo === "leadform") {
      // Scroll to ContactForm
      const form = document.getElementById("leadform");
      if (form) form.scrollIntoView({ behavior: "smooth" });
    } else {
      // Navigate to page
      navigate(currentSlideData.navigateTo);
    }
  };

  return (
    <>
      <section className="relative w-full h-[85vh] overflow-hidden">
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${IMAGE_1})` }}
        />
        <div className="absolute inset-0 bg-black/50 z-10" />

        {/* Main Content */}
        <div className="relative z-20 h-full max-w-7xl mx-auto px-6 flex items-center">
          {/* LEFT CONTENT */}
          <div className="w-full lg:w-2/3">
            {/* Dots */}
            <div className="flex gap-2 mb-6">
              {slides.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentSlide(i)}
                  className={`h-3 rounded-full transition-all ${currentSlide === i
                    ? "w-10 bg-yellow-400"
                    : "w-3 bg-white/30"
                    }`}
                />
              ))}
            </div>

            {/* Text */}
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 max-w-3xl">
              {slides[currentSlide].title}
            </h1>

            <p className="text-lg md:text-xl text-white/90 max-w-2xl mb-8">
              {slides[currentSlide].description}
            </p>

            {/* Main CTA Button - Already exists, just add onClick */}
            <button
              onClick={handleCTA}
              className="flex items-center gap-2 bg-yellow-400 text-black font-bold px-8 py-3 rounded-xl hover:bg-yellow-500 transition-colors"
            >
              {slides[currentSlide].cta}
              <ArrowRight />
            </button>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12 max-w-3xl">
              {stats.map((stat, i) => (
                <div key={i}>
                  <div className="text-3xl font-bold text-yellow-400">
                    {stat.value}
                  </div>
                  <div className="text-white/80">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT VERTICAL INDICATOR — ALWAYS VISIBLE */}
        <div className="absolute right-4 top-1/2 -translate-y-1/2 z-30 hidden lg:flex flex-col items-center">
          <div className="h-20 w-[2px] bg-yellow-400/40 mb-3" />
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentSlide(i)}
              className={`text-lg transition ${currentSlide === i
                ? "text-yellow-400 font-bold"
                : "text-white/50"
                }`}
            >
              {String(i + 1).padStart(2, "0")}
            </button>
          ))}
          <div className="h-20 w-[2px] bg-yellow-400/40 mt-3" />
        </div>
      </section>

      {/* FORM — SHOWS BELOW ON MOBILE, FIXED POSITION ON DESKTOP */}
      <div className="lg:absolute lg:right-10 lg:top-[54%] lg:-translate-y-1/2 lg:z-20 lg:block lg:w-[420px] 
                w-full px-6 py-8 bg-white lg:bg-transparent">
        <ContactForm />
      </div>
    </>
  );
};

export default HeroSection;